var _defs, _path, _rect, _rect2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossAbility(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "CROSS_ABILITY",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      #CROSS_ABILITY .cls-1 {\n        fill: #c5d75d;\n      }\n\n      #CROSS_ABILITY .cls-2 {\n        fill: #f5f5f5;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_125",
    "data-name": "Pfad 125",
    className: "cls-1",
    d: "M16,2A14,14,0,1,1,2,16,14.041,14.041,0,0,1,16,2m0-2A16,16,0,1,0,32,16,15.983,15.983,0,0,0,16,0Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_31",
    "data-name": "Rechteck 31",
    className: "cls-2",
    width: 3,
    height: 9,
    transform: "translate(14.5 3.8)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_32",
    "data-name": "Rechteck 32",
    className: "cls-2",
    width: 3,
    height: 9,
    transform: "translate(14.5 19)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_126",
    "data-name": "Pfad 126",
    className: "cls-2",
    d: "M21.6,9.5l-.7.8L26,15.4H5.8v1H26l-5.1,5.1.7.8L28,15.9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossAbility);
export default __webpack_public_path__ + "static/media/cross-ability.d89ca82a262c0db5ce9d09a52c9b7643.svg";
export { ForwardRef as ReactComponent };